module.exports = __webpack_public_path__ + "img/news-banner.50dd160a.png";